var map = {
	"./Teacher_invite.svg": 5772,
	"./Teacher_invite_accepted.svg": 4148,
	"./Teacher_invite_accepted_dark.svg": 3475,
	"./Teacher_invite_dark.svg": 939,
	"./Teacher_invite_declined.svg": 2393,
	"./Teacher_invite_declined_dark.svg": 2624,
	"./arrows-icon.svg": 9542,
	"./check.svg": 7486,
	"./cross.svg": 7838,
	"./danger-logo-dark.svg": 9002,
	"./danger-logo.svg": 3129,
	"./door-left-logo-dark.svg": 6417,
	"./door-left-logo.svg": 6220,
	"./ekool-logo.svg": 7228,
	"./eliis-logo.svg": 7638,
	"./email_not_updated_dark.svg": 411,
	"./email_not_updated_light.svg": 6209,
	"./email_updated_dark.svg": 1805,
	"./email_updated_light.svg": 2843,
	"./exclamation.svg": 2857,
	"./fonts/permissions.svg": 7945,
	"./google-logo.svg": 3697,
	"./illustration-dark.svg": 5133,
	"./illustration.svg": 6976,
	"./info.svg": 4646,
	"./key-icon--grayscale400.svg": 4922,
	"./key-icon--grayscale600.svg": 1624,
	"./key-icon-black.svg": 8833,
	"./key-icon-white.svg": 6087,
	"./key-icon.svg": 4791,
	"./letter-logo-white.svg": 4198,
	"./letter-logo.svg": 4586,
	"./lock-locked-logo.svg": 8930,
	"./maintenance.svg": 2127,
	"./microsoft-logo.svg": 8894,
	"./passkey-logo-blue.svg": 8775,
	"./passkey-logo-white.svg": 626,
	"./passkey-logo.svg": 2582,
	"./password_hide.svg": 1200,
	"./password_show.svg": 9779,
	"./phone-logo-white.svg": 2058,
	"./phone-logo.svg": 6014,
	"./protected-logo.svg": 8544,
	"./shape.svg": 1261,
	"./sms-logo-white.svg": 4124,
	"./sms-logo.svg": 1420,
	"./spinner.svg": 5353,
	"./welcome.svg": 3330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;